import { AxiosRequestConfig } from 'axios';

import backend from '@common/backend';
import { ICreditCustomersQuery } from '@common/types/api/creditCustomersTypes';

export interface UpdateQuizSlide {
	onboarding_quiz_slide_id: number;
	is_completed: boolean;
	selected_answer_option_ids?: number[];
	text_answer?: string;
}

export interface UpdateQuiz {
	onboarding_quiz_id: number;
	is_completed: boolean;
}

export enum UserActionTypes {
	OpenedConsultationLink = 'opened_consultation_link',
	FirstInteraction = 'first_interaction',

	VisitedDashboard = 'visited_dashboard',
	VisitedEducation = 'visited_education',
	VisitedFinancial = 'visited_financial',
	VisitedStudents = 'visited_students',
	VisitedLaunch = 'visited_launch',
	VisitedDocuments = 'visited_documents',
	VisitedPayment = 'visited_payment',
	VisitedThankYou = 'visited_thank_you',
	VisitedStudentEducation = 'visited_student_education',
	VisitedStudentTests = 'visited_student_tests',
	MemorandumSigned = 'memorandum_signed',

	ShouldShowNps = 'should_show_nps',
	DashboardMessageClosed = 'dashboard_message_closed',

	LaunchedFirstTraining = 'launched_first_training',
	VisitedPartnerDocuments = 'visited_partner_documents',

	TeacherCertificateDownloaded = 'teacher_certificate_downloaded',
	// ShouldShowNps = 'should_show_nps',

	CgVisitedSchool = 'cg_visited_school',
	CgVisitedStudents = 'cg_visited_students',
	CgVisitedTest = 'cg_visited_test',
	CgVisitedControls = 'cg_visited_control',
	CgVisitedReport = 'cg_visited_report',
}

const BASE = '/users';

export const getUsers = async (query: any) =>
	backend.get(`${BASE}/`, {
		params: query,
	});

export const getUser = async (id: number) => backend.get(`${BASE}/${id}`);

export const createUser = async (userRoleKey: string, data: any) =>
	backend.post(`/${userRoleKey}`, {
		...data,
		first_name_ua: data.first_name,
		last_name_ua: data.last_name,
		// password: '[3DxdJ5_r[>g',
		// password_confirmation: '[3DxdJ5_r[>g',
	});

const resetUserPasswordFromBE = (user: any) => ({
	...user,
	password_email_sent: user.password_email_sent ? 1 : 0,
});

export const resetUserPassword = async (id: number) =>
	backend.get(`${BASE}/${id}/password/reset`).then(resetUserPasswordFromBE);

export interface IChangeUserPassword {
	old_password: string;
	password: string;
	password_confirmation: string;
}

export const changeUserPassword = async (data: IChangeUserPassword) =>
	backend.patch(`${BASE}/password/update`, data);

export const attachRole = async (userId: number, roleId: number, data: any) =>
	backend.put(`${BASE}/${userId}/roles/${roleId}`, data);

export const detachRole = async (userId: number, roleId: number) =>
	backend.delete(`${BASE}/${userId}/roles/${roleId}`);

export const changeUserLanguage = async (data: any) =>
	backend.patch(`${BASE}/update-default-lang`, data);

export const commitAction = async ({ actionType }: { actionType: UserActionTypes }) =>
	backend.post(`${BASE}/actions`, {
		action: actionType,
	});

export const getRoles = async (query: any) =>
	backend.get(`${BASE}/roles`, {
		params: query,
	});

export const getUsersAvailableQuiz = async () => backend.get(`${BASE}/getAvailableQuiz`);

export const putUsersQuizSlides = async (data: UpdateQuizSlide) =>
	backend.put(`${BASE}/onboardingQuizSlides`, data);

export const putUsersQuiz = async (data: UpdateQuiz) =>
	backend.put(`${BASE}/onboardingQuizzes`, data);

export const getCreditCustomers = async (
	query: ICreditCustomersQuery,
	config: AxiosRequestConfig = {},
) =>
	backend.get(`${BASE}/credit-customers`, {
		...config,
		params: query,
	});

export const exportCreditCustomers = async (status?: string): Promise<Blob> =>
	backend.get(`${BASE}/credit-customers/export`, {
		params: {
			format: 'xlsx',
			...(status && { status }),
		},
		responseType: 'blob',
	});
